import React, { useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogContent } from '@material-ui/core'
import { Button } from '@material-ui/core'
import { Image, Spinner } from 'ui'
import { observer } from 'mobx-react'
import useStore from 'store'

import Close1Icon from 'assets/icons/ims/Close2.svg'
import EmergencyIcon3 from 'assets/icons/ims/EmergencyIcon3.svg'

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 31.989px;
  flex-shrink: 0;display: flex;
  height: 186.932px;
  padding: 23.991px 23.991px 0 23.991px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  background: #FFF;
`
const DialogBody = styled(DialogContent)`
  background: white;
  border-top-width: 1px;
  overflow-y: none;
`
const TopContainer = styled.div`
  display: flex;
  height: 82.969px;
  padding-right: 0;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
const ConfirmButton = styled(Button)`
  display: flex;
  height: 40px;
  padding: 7px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: #F1F5F9;
  color: #0F172A;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const DeleteButton = styled(Button)`
  display: flex;
  padding: 8.724px 15.875px 7.276px 15.994px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #DC2626;
  color: #FFF;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const CloseButton = styled(Button)`
  min-width: 0px;
  padding: 0px;
`
const ImageIcon = styled(Image)`
  display: flex;
  width: 27.983px;
  height: 27.983px;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
`
const ImageEmergencyIconContainer = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: rgba(220, 38, 38, 0.10);
`
const ImageEmergencyIcon = styled(Image)`
  width: 20.969px;
  height: 20.969px;
`
const TopHeader = styled.div`
  display: flex;
  height: 82.969px;
  flex-direction: column;
  align-items: flex-end;
  gap: 7.997px;
  flex: 1 0 0;
`
const TopHeader1 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #0F172A;
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 27px;
`
const TopHeader2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #64748B;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`

const RemoveCategoryModal = ({ open, closeModal, categoryId, categoryName }) => {
  const { orgs, protocolsStore } = useStore()
  const [deleting, setDeleting] = useState(false)

  const handleDelete = async () => {
    setDeleting(true)
    await protocolsStore.deleteCategory(orgs.currentOrgId, categoryId)
    await protocolsStore.loadCategories(orgs.currentOrgId)
    setDeleting(false)
    closeModal(false)
  }

  return (
    <>
      <Dialog style={{ zIndex: 1300 }} open={open} maxWidth={'lg'}>
        <DialogBody>
          <BodyContainer>
            <TopContainer>
              <ImageEmergencyIconContainer>
                <ImageEmergencyIcon src={EmergencyIcon3} />
              </ImageEmergencyIconContainer>
              <TopHeader>
                <TopHeader1>מחיקת איש קשר</TopHeader1>
                <TopHeader2>
                  האם אתה בטוח שברצונך למחוק את {categoryName}?<br />
                  פעולה זו אינה ניתנת לביטול.
                </TopHeader2>
              </TopHeader>
              <CloseButton onClick={() => closeModal(false)}>
                <ImageIcon src={Close1Icon} />
              </CloseButton>
            </TopContainer>
            <BottomContainer>
              <ConfirmButton onClick={() => closeModal(false)}>ביטול</ConfirmButton>
              <DeleteButton onClick={handleDelete} disabled={deleting}>
                {deleting ? <Spinner size={16} /> : 'מחק'}
              </DeleteButton>
            </BottomContainer>
          </BodyContainer>
        </DialogBody>
      </Dialog>
    </>
  )
}

export default observer(RemoveCategoryModal)
